// startup
// Load entry module and return exports
__webpack_require__(3472);
// This entry module doesn't tell about it's top-level declarations so it can't be inlined
var __webpack_exports__ = __webpack_require__(5879);
